import i18nHandle from '../locales';
import { hasPermission } from './permission'
import { hasSetting } from './setting'

export const forEachMenuList = (menuList, callback) =>
  menuList.forEach(menuItem => {
    callback(menuItem);

    if (menuItem.subMenu) {
      forEachMenuList(menuItem.subMenu, callback);
    }
  });

export const filterMenuList = ({ menuList, privilege, setting, system, hostMap = [] }) => {
  // 鉴权
  const checkPermission = curMenuList =>
    curMenuList.filter(menu => {
      const isPermission = hasPermission(privilege, menu.roles ? menu.roles : '')
      const isSetting = hasSetting(setting, menu.setting ? menu.setting : '')
      return isPermission && isSetting
    });

  // 重组 menulist
  const recombineMenuList = (function loop(menus, parentMenu = []) {
    return checkPermission(menus).map(menu => {
      const urlHeader = menu.system && menu.system !== system ?  hostMap[menu.system] : ''
      const newMenu = {
        ...menu,
        id: menu.id,
        name: i18nHandle.t(`menu.${menu.id}`),
        parentMenu: null,
        subMenu: null,
        url: urlHeader ? `${urlHeader}${menu.url}` : menu.url,
      };
      newMenu.parentMenu = parentMenu || null;
      newMenu.subMenu = menu.subMenu ? loop(menu.subMenu, [...parentMenu, newMenu.id]) : '';

      return newMenu;
    });
  })(menuList);

  return recombineMenuList.filter(menu => !menu.subMenu || menu.subMenu.length);
};

export default {};
